import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import { MultiSelect } from 'primereact/multiselect'
import { SketchPicker } from 'react-color'
import { ColorPicker } from 'primereact/colorpicker'
import classNames from 'classnames'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast'
import { Button } from 'primereact/button'
import { Rating } from 'primereact/rating'
import { Toolbar } from 'primereact/toolbar'
import { InputTextarea } from 'primereact/inputtextarea'
import { RadioButton } from 'primereact/radiobutton'
import { InputNumber } from 'primereact/inputnumber'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import Modal from 'react-bootstrap/Modal'
import reactCSS from 'reactcss'
import ColorForm from '../ColorForm'
import DraggableModalDialog from '../../common/DraggableModalDialog'
import * as instructorActions from '../../../_actions/customization/colors.actions'

class ColorCustomization extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedColors: null,
            submitted: false,
            globalFilter: null,
            color: '',
            selectedColor: null,
            show: false,
            delmodal: false,
            deleteColors: false,
            displayColorPicker: false,
            displayColorNormalPicker: false,
            displayColorLeavePicker: false,
            colorNormal: '#9B9B9B',
            colorLeave: '#9B9B9B',
        }

        this.colorBodyTemplate = this.colorBodyTemplate.bind(this)
        this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this)
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this)
        this.confirmDeleteSelected = this.confirmDeleteSelected.bind(this)
        this.deleteSelectedColors = this.deleteSelectedColors.bind(this)
    }

    componentDidMount() {
        if (this.props.colors == undefined) {
            this.props.actions.getColors()
        }

        this.setState({ mounted: true })
    }

    newColor = () => {
        this.setState({
            selectedColor: {},
        })
        this.handleShow()
    }


    confirmDeleteSelected() {
        this.handleDelColorsShow()
    }

    deleteSelectedColors() {

        this.props.actions
            .removeColors(this.state.selectedColors)
            .then(res => this.handleDelColorsClose())
            .then(res => {
                this.setState({
                    deleteColors: false,
                    selectedColors: null,
                })
                this.toast.show({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Custom Colors Deleted',
                    life: 3000,
                })
            })
            .catch(error => {
                console.log(`error=${error}`)
            })

    }


    leftToolbarTemplate() {
        return (
            <React.Fragment>
                <Button
                    label="New"
                    icon="pi pi-plus"
                    className="p-button-success p-mr-2"
                    onClick={this.newColor}
                />
                <Button
                    label="Delete"
                    icon="pi pi-trash"
                    className="p-button-danger"
                    onClick={this.confirmDeleteSelected}
                    disabled={
                        !this.state.selectedColors ||
                        !this.state.selectedColors.length
                    }
                />
            </React.Fragment>
        )
    }

    colorBodyTemplate(rowData) {
        const styles = reactCSS({
            default: {
                colorNormal: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: rowData.PayrollColorNormalCode,
                },
                colorLeave: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: rowData.PayrollColorLeaveCode,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        })
        return (
            <div>
                <div style={styles.swatch}>
                    <div style={styles.colorNormal} />
                </div>
                <div style={styles.swatch}>
                    <div style={styles.colorLeave} />
                </div>
            </div>
        )
    }


    actionBodyTemplate(rowData) {
        return (
            <div className="btn-toolbar">
                <Button
                    label=""
                    type="button"
                    icon="pi pi-pencil"
                    className="p-button-success p-mr-2"
                    onClick={() => this.rowClick(rowData)}
                    tooltip="Edit"
                    tooltipOptions={{ position: 'bottom' }}
                ></Button>
                <Button
                    label=""
                    type="button"
                    icon="pi pi-trash"
                    className="p-button-warning"
                    onClick={() => this.rowDelete(rowData)}
                    tooltip="Delete"
                    tooltipOptions={{ position: 'bottom' }}
                ></Button>
            </div>
        )
    }

    rowClick = rowData => {
        this.setState({
            selectedColor: rowData,
        })

        this.handleShow()
    }

    rowDelete = rowData => {
        this.setState({
            selectedColor: rowData,
        })
        this.handleDelModalShow()
    }

    handleShow = () => {
        this.setState({ show: true })
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    handleDelModalClose = () => {
        this.setState({ delmodal: false })
    }

        handleDelColorsClose = () => {
        this.setState({ deleteColors: false })
    }

    handleDelModalShow = () => {
        this.setState({ delmodal: true })
    }

    handleDelColorsShow = () => {
        this.setState({ deleteColors: true })
    }

    tableBodyData = () => {
        const colors = _.map(this.props.colors, (obj, key) => {
            obj.PayrollBranchName = this.findBranchName(obj.PayrollBranch)
            obj.PayrollDepartmentName = this.findDepartmentName(
                obj.PayrollDepartment
            )
            obj.PayrollCompanyJobTypeName = ''

            return obj
        })

        return colors
    }

    findBranchName = branchId => {
        const { branches } = this.props
        const branch = _.find(branches, { value: `${branchId}` })

        return branch !== undefined ? branch.label : ''
    }

    findDepartmentName = departmentId => {
        const { departments } = this.props

        const department = _.find(departments, { value: `${departmentId}` })

        return department !== undefined ? department.label : ''
    }

    remove = event => {
        const id = this.state.selectedColor.id
        this.props.actions
            .removeColorsById(id)
            .then(res => this.handleDelModalClose())
            .then(res => {
                this.toast.show({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Custom Color Deleted',
                    life: 3000,
                })
            })
            .catch(error => {
                console.log(`error=${error}`)
            })
    }

    render() {
        const colors = this.tableBodyData()

        const header = (
            <div className="table-header">
                {/* <h5 className="p-m-0">Manage Products</h5> */}
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        type="search"
                        onInput={e =>
                            this.setState({ globalFilter: e.target.value })
                        }
                        placeholder="Search..."
                    />
                </span>
            </div>
        )

        return (
            <div className="row">
                <div className="col-sm-12 col-md-12">
                    <div className="panel">
                        <div className="panel-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12">
                                        <div>
                                            <Toast
                                                ref={el => (this.toast = el)}
                                            />

                                            <div>
                                                <Toolbar
                                                    className="p-mb-4"
                                                    left={
                                                        this.leftToolbarTemplate
                                                    }
                                                    // right={this.rightToolbarTemplate}
                                                ></Toolbar>

                                                <DataTable
                                                    ref={el => (this.dt = el)}
                                                    value={colors}
                                                    selection={
                                                        this.state
                                                            .selectedColors
                                                    }
                                                    onSelectionChange={e =>
                                                        this.setState({
                                                            selectedColors:
                                                                e.value,
                                                        })
                                                    }
                                                    dataKey="id"
                                                    paginator
                                                    rows={10}
                                                    rowsPerPageOptions={[
                                                        5,
                                                        10,
                                                        25,
                                                    ]}
                                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
                                                    globalFilter={
                                                        this.state.globalFilter
                                                    }
                                                    header={header}
                                                >
                                                    <Column
                                                        selectionMode="multiple"
                                                        headerStyle={{
                                                            width: '3rem',
                                                        }}
                                                    ></Column>
                                                    <Column
                                                        field="PayrollColorCode"
                                                        header="Color"
                                                        sortable
                                                        body={
                                                            this
                                                                .colorBodyTemplate
                                                        }
                                                    ></Column>
                                                    <Column
                                                        field="PayrollBranchName"
                                                        header="Branch"
                                                        sortable
                                                    ></Column>
                                                    <Column
                                                        field="PayrollDepartmentName"
                                                        header="Department"
                                                        sortable
                                                    ></Column>
                                                    {/* <Column
                                                        field="PayrollCompanyJobTypeName"
                                                        header="Job"
                                                        sortable
                                                    ></Column> */}
                                                    <Column
                                                        body={
                                                            this
                                                                .actionBodyTemplate
                                                        }
                                                    ></Column>
                                                </DataTable>
                                            </div>

                                            <Modal
                                                dialogComponentClass={
                                                    DraggableModalDialog
                                                }
                                                dialogClassName="mod-w450"
                                                show={this.state.show}
                                                onHide={this.handleClose}
                                            >
                                                <div>
                                                    <div>
                                                        <Modal.Header
                                                            closeButton
                                                        >
                                                            <Modal.Title>
                                                                Custom Color
                                                            </Modal.Title>
                                                        </Modal.Header>
                                                        <ColorForm
                                                            handleClose={this.handleClose.bind(
                                                                this
                                                            )}
                                                            data={
                                                                this.state
                                                                    .selectedColor
                                                            }
                                                            branches={
                                                                this.props
                                                                    .branches
                                                            }
                                                            departments={
                                                                this.props
                                                                    .departments
                                                            }
                                                            employees={
                                                                this.props
                                                                    .employees
                                                            }
                                                            actions={
                                                                this.props
                                                                    .actions
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </Modal>

                                            <div className="modal-sm">
                                                <Modal
                                                    show={this.state.delmodal}
                                                    onHide={
                                                        this.handleDelModalClose
                                                    }
                                                    dialogClassName="mod-w400"
                                                >
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>
                                                            <span>
                                                                Confirm Delete
                                                            </span>
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <span>
                                                            Are you sure?
                                                        </span>
                                                        <div className="modal-footer">
                                                            <button
                                                                type="button"
                                                                className="btn btn-success pull-left btn-sm-w"
                                                                onClick={
                                                                    this.remove
                                                                }
                                                            >
                                                                Yes
                                                            </button>

                                                            <button
                                                                type="submit"
                                                                className="btn btn-default btn-sm-w"
                                                                onClick={
                                                                    this
                                                                        .handleDelModalClose
                                                                }
                                                            >
                                                                No
                                                            </button>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            </div>

                                            <div className="modal-sm">
                                                <Modal
                                                    show={
                                                        this.state.deleteColors
                                                    }
                                                    onHide={
                                                        this.handleDelColorsClose
                                                    }
                                                    dialogClassName="mod-w400"
                                                >
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>
                                                            <span>
                                                                Confirm Delete
                                                            </span>
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <span>
                                                            Are you sure?
                                                        </span>
                                                        <div className="modal-footer">
                                                            <button
                                                                type="button"
                                                                className="btn btn-success pull-left btn-sm-w"
                                                                onClick={
                                                                    this.deleteSelectedColors
                                                                }
                                                            >
                                                                Yes
                                                            </button>

                                                            <button
                                                                type="submit"
                                                                className="btn btn-default btn-sm-w"
                                                                onClick={
                                                                    this
                                                                        .handleDelColorsClose
                                                                }
                                                            >
                                                                No
                                                            </button>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        colors: state.colors.colors,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        employees: state.DepartmentReducer.departmentList,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(ColorCustomization)
